var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutdoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7026 16.902H19.6804V15.4971H16.2149H12.7026V8.32166H11.2977V15.4971H7.78533H4.31982V16.902H11.2977V21.4957L9.10596 24.4887H10.8471L12.0001 22.9147L13.1531 24.4887H14.8943L12.7026 21.4957V16.902Z",
    fill: "#F2EADF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4264 0.511353L0 6.91691H7.04995L10.4264 0.511353Z",
    fill: "#F2EADF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3631 6.91664L12.0001 0.521851L8.63721 6.91664H15.3631Z",
    fill: "#F2EADF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 6.91667L13.5801 0.511108L16.9502 6.91667H24.0001Z",
    fill: "#F2EADF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6384 18.3069H17.5088V24.4886H18.9137V21.5851H21.5363V24.4886H22.9412V19.0645L23.916 12.8904L22.5283 12.6713L21.6384 18.3069Z",
    fill: "#F2EADF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45459 12.6713L0.0668945 12.8904L1.04173 19.0645V24.4886H2.44666V21.5851H5.0692V24.4886H6.47414V18.3069H2.34443L1.45459 12.6713Z",
    fill: "#F2EADF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6199 14.0921V12.6871H14.8101V14.0921C14.8101 14.868 15.439 15.497 16.215 15.497C16.9909 15.497 17.6199 14.868 17.6199 14.0921Z",
    fill: "#F2EADF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19024 14.0921V12.6871H6.38037V14.0921C6.38037 14.868 7.00936 15.497 7.7853 15.497C8.56125 15.497 9.19024 14.868 9.19024 14.0921Z",
    fill: "#F2EADF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutdoor);
export default __webpack_public_path__ + "static/media/outdoor.1de32c91ff81c02eba41ccaebb8deb64.svg";
export { ForwardRef as ReactComponent };